<div class="container confetti">
    <div class="white-container">
        <h2 class="message">{{ (state ? state.message : "message_default") | locale }}</h2>
    </div>
</div>
